export const IMAGE_SRC_TYPES = Object.freeze({
  IMAGE: 'image',
  DROPBOX: 'dropbox',
  UPLOAD: 'upload',
  YOUTUBE: 'youtube'
})
